import { render } from "./Folder.vue.js?vue&type=template&id=6246d1a0!=!../vue-loader/dist/index.js??ruleSet[0]!./Folder.vue?vue&type=template&id=6246d1a0"
import script from "./Folder.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Folder.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__